import { useModalContext } from '@sketch/components'
import { useFlag } from '@sketch/modules-common'
import { useVersioning } from 'modules/versioning'

import ShareSettingsModal from '../../../modals/ShareSettingsModal'
import SharingModal from '../../../modals/SharingModal'

export const useShareModal = () => {
  const { share, latestVersion } = useVersioning()
  const { showModal } = useModalContext()
  const isNewSharingOn = useFlag('new-sharing')

  if (isNewSharingOn) {
    return () => {
      showModal(SharingModal, { share, latestVersion })
    }
  }

  return () => {
    showModal(ShareSettingsModal, { share })
  }
}
